import { SxProps } from '@mui/material';
import { useTranslation } from '../../hooks/i18n';
import { filesURL } from '../../constants/auth';
import Typography from '../Typography';

interface TermsAndConditionsLabelProps {
  firstPart?: string;
  sx?: SxProps;
}

const TermsAndConditionsLabel = ({ firstPart, sx }: TermsAndConditionsLabelProps) => {
  const { t } = useTranslation();

  return (
    <Typography sx={sx}>
      {firstPart || `${t('termsAndConditionsFirstPart')} `}
      <a
        href={`${filesURL}/${t('signup.termsAndConditionsDocument')}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {`${t('signup.termsAndConditions')}`}
      </a>
      {`${t('signup.termsAndConditionsSecondPart')} `}
      <a
        href={`${filesURL}/${t('signup.privacyPolicyDocument')}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {t('signup.privacyPolicy')}
      </a>
    </Typography>
  );
};

export default TermsAndConditionsLabel;
